export { default as Head } from './Head';
